import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AnalyticsApi } from '@core/api/analytics/api';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(private _http: HttpClient) {}

  exportKpiReport(period: string, relative: string): Observable<Blob> {
    const { url } = AnalyticsApi.exportKpiReport(period, relative);
    return this._http.get(url, { responseType: 'blob' });
  }

  exportKpiReportByDateRange(startDate: string, endDate: string): Observable<Blob> {
    const { url } = AnalyticsApi.exportKpiReportByDateRange(startDate, endDate);
    return this._http.get(url, { responseType: 'blob' });
  }
}
